/**
 * AI:
 * Status: "in progress"
 * Type: Service
 * SubType: Domain
 * Reason: The read-only jumps of the cp review panes — "Vertrag öffnen" (cm.Contract) and
 *         "Abrechnungskonto öffnen" (cp.ProvisionAgent) — in ONE place instead of five copies.
 *         Both navigate with `MvsObjectNavigationActionEnum.display`: a review only LOOKS at the
 *         target object, it never opens it for editing.
 */
import {MvsObjectNavigationService} from 'features/core/shared/navigation/mvs-object-navigation.service';
import {MvsObjectNavigationEntry} from 'features/core/shared/navigation/mvs-object-navigation-entry';
import {MvsObjectNavigationActionEnum} from 'features/core/shared/navigation/mvs-object-navigation-action-enum';

/**
 * Open one object on its object page in the main area, read-only (`display`).
 *
 * `display` still resolves the OBC registered for update mode: the object page derives the CRUD
 * mode from the presence of an object id, the action only says what the user intends to do.
 *
 * @param navigationService the standard object navigation
 * @param objectType        entity alias, e.g. `cm.Contract`
 * @param objectId          id of the object; nothing happens without one
 */
export function cpOpenObjectForDisplay(navigationService: MvsObjectNavigationService,
                                       objectType: string,
                                       objectId: number | null | undefined): void {
    if (!objectId) {
        return;
    }
    const entry = MvsObjectNavigationEntry.createNavigationEntry(
        objectType,
        objectId,
        'object', '', '', '',
        MvsObjectNavigationActionEnum.display
    );
    navigationService.navigateTo(entry, 'main');
}

/** "Vertrag öffnen" — the cm contract page, read-only. */
export function cpOpenContract(navigationService: MvsObjectNavigationService,
                               contractId: number | null | undefined): void {
    cpOpenObjectForDisplay(navigationService, 'cm.Contract', contractId);
}

/** "Abrechnungskonto öffnen" — the object page of a `cp.ProvisionAgent`, read-only. */
export function cpOpenProvisionAgent(navigationService: MvsObjectNavigationService,
                                     provisionAgentId: number | null | undefined): void {
    cpOpenObjectForDisplay(navigationService, 'cp.ProvisionAgent', provisionAgentId);
}
